export default "__VITE_ASSET__24ecf2e8__"